import Seo from '../components/Seo';
import HeroSection from '../components/home/HeroSection';
import HowItWorks from '../components/home/HowItWorks';
import FeatureSections from '../components/home/FeatureSections';
import ObjectionPreemption from '../components/home/ObjectionPreemption';
import Testimonials from '../components/home/Testimonials';
import ExpertProfile from '../components/home/ExpertProfile';
import PricingSection from '../components/home/PricingSection';
import FAQSection from '../components/home/FAQSection';
import CTASection from '../components/home/CTASection';

const Home = () => (
  <div className="bg-[#0F1419]">
    <Seo path="/" />
    <HeroSection />
    <HowItWorks />
    <FeatureSections />
    <ObjectionPreemption />
    <Testimonials />
    <ExpertProfile />
    <PricingSection />
    <FAQSection />
    <CTASection />
  </div>
);

export default Home;
